import styles from "./index.module.css";
import { useEffect, useRef } from "react";
const Misaligned = (props) => {
    const svgRef = useRef(null);
  useEffect(() => {
    svgRef.current.querySelectorAll("path").forEach((element) => {
        element.style.setProperty("--effect-path-length",`${element.getTotalLength()}px`);
    });
  }, []);
  return (
    <svg
      ref={svgRef}
      width="889"
      height="204"
      viewBox="0 0 889 204"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`${styles.svg} ${props.className}`}
    >
      <path
        d="M2.5 134.5C43.5 128 195.426 55.5575 240.5 14.4999C291 -31.5001 187.069 98.3291 155 156.5C133.5 195.5 271.5 64.9999 334.5 8.49994C378.5 -30.9604 267 121 229.5 194.5"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M332.135 82.3613C322 93.0002 292.5 142.5 354.194 106.633C358.301 85.8022 403.138 73.3545 383.774 99.814C380.709 104.001 391.402 89.6818 386.708 86.3039C381.238 82.3682 353.653 96.9928 356 106C358.934 117.26 383.653 120.533 366 131.905C324.924 158.366 307 138 418.5 106.633C428.5 96.0002 446.5 92.5002 453.5 96.0002C461.902 100.201 439 83.3613 415.5 111C408.517 119.213 422 129.5 470 83.5002C473.328 80.3107 427.5 143.5 491.5 112C498 102 510.5 84.5 502 87C523.5 78.6963 556.136 48.0003 566.5 29.0001C581.5 1.50008 531.517 45.447 505.5 89.5004C424 227.5 535 123 552 91C558.099 79.5202 502 154.5 571 117.5C577.5 109.167 590 93.3571 613 95C634 96.5 590 87 573 117.5C569.221 124.28 612.858 110.425 618.5 93.5C624 77 588.335 189.896 520 200.5C462 209.5 513 153.592 659 119C660.5 118.645 670.031 104.288 673 100C677.5 93.5 656.522 122.358 648.5 133.5C639.5 146 719 82 701 120.5C684.706 155.35 710.5 139.5 747 121.5C791 120 784.353 91.7223 751 114.5C730.5 128.5 761 145.5 808 123C828.5 106 850.195 111.662 840.5 111.5C810.5 111 791.5 144 814.5 132.5C852.471 113.514 878.5 64.5 885 58.5C891.5 52.5 844.737 113.771 822.5 161.5C802 205.5 870 143.5 886.5 128.5"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M349 61C346.5 63 344 65.5 342 69"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
      <path
        d="M569 69C566.5 71 564 73.5 562 77"
        stroke="white"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="bevel"
      />
    </svg>
  );
};

export default Misaligned;
